import produce from 'immer';
import * as REQUEST_STATES from 'forms-utils-lib/RequestState';
import { REQUEST_PORTAL_SCOPES, RECEIVE_PORTAL_SCOPES, FAIL_PORTAL_SCOPES } from 'FormsUI/actions/PortalScopes';
const INIT_STATE = {
  portalScopes: [],
  portalScopesRequestState: REQUEST_STATES.NOT_REQUESTED
};
export const portalScopes = produce((scopes, action) => {
  switch (action.type) {
    case REQUEST_PORTAL_SCOPES:
      scopes.portalScopesRequestState = REQUEST_STATES.REQUESTED;
      scopes.portalScopes = [];
      break;
    case RECEIVE_PORTAL_SCOPES:
      {
        scopes.portalScopesRequestState = REQUEST_STATES.SUCCEEDED;
        if ('portalScopes' in action) {
          scopes.portalScopes = action.portalScopes;
        }
        break;
      }
    case FAIL_PORTAL_SCOPES:
      {
        scopes.portalScopesRequestState = REQUEST_STATES.FAILED;
        scopes.portalScopes = [];
        break;
      }
    default:
      break;
  }
}, INIT_STATE);
export default portalScopes;